<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn small depressed fab
        v-on="on"
        color="secondary darken-1">
        <v-badge color="transparent">
          <v-icon size="20" color="white">fa-user</v-icon>
        </v-badge>
      </v-btn>
    </template>
  </v-menu>
</template>

<script>
export default {
  name: 'profile-toolkit',
  computed: {
    printClientName () {
      let name = this.$store.getters['client/get']('name').join(' ')
      return (name === ' ') ? '' : name
    },
    printClientKana () {
      return this.$store.getters['client/get']('kana').join(' ')
    }
  }
}
</script>

<style lang="scss">
#profileToolkit {
  display: flex;
  flex: 1 0;
  .cli-name {
    position: relative;
    .ruby {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
